import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";


const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class ChangeAccountNumberDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            emailState: '',
            email: '',
            loading: false
        }
    }

    validateEmail(newEmail) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(newEmail)) {
            return 'success';
        }
        return 'error';
    }

    submit() {
        if (this.state.emailState === 'success') {
            this.setState({ loading: true }, () => {
                this.props.close();
                this.props.CreateEmail(this.state.email)

                this.setState({ loading: false, email: '', emailState: '' });
            })
        } else {
            this.setState({ emailState: 'error' });
        }
    }

    render() {


        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Email</DialogTitle>
                <DialogContent>
                    <CustomInput
                        success={this.state.emailState === "success"}
                        error={this.state.emailState === "error"}
                        labelText={
                            <span>
                                New Email <small>(required)</small>
                            </span>
                        }
                        id="email"
                        formControlProps={{
                            fullWidth: true
                        }}
                        //labelProps={{ shrink: true }}
                        inputProps={{
                            onChange: event => this.setState({ email: event.target.value, emailState: this.validateEmail(event.target.value) }),
                            value: this.state.email,
                            onKeyPress: ({ nativeEvent }) => {
                                if (nativeEvent.keyCode == 13) {
                                    this.submit();
                                }
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Add Email
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(ChangeAccountNumberDialog);